module.exports = __webpack_public_path__ + "img/platinum.730ddb6f.svg";